import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import { Spinner, Icon } from 'platfi-ui-components';

import { bemClassName } from 'utils/BEMHelper';

import { shareableReportInputState } from 'enums/shareable-report-input-state';

import styles from './ShareableReportTitledSpinner.scss';

const { failure, success, loading, idle } = shareableReportInputState;

const getViewFromState = (state, stylesName) => {
  const defaultView = {
    Component: Icon,
    props: {
      styleName: stylesName,
      className: 'a-svg-large',
      icon: 'round_outlined_check',
    },
    title: 'Changes Saved',
  };

  const options = {
    [loading]: {
      Component: Spinner,
      props: {
        styleName: stylesName,
        className: 'a-svg-large',
      },
      title: 'Saving Changes',
    },
    [failure]: {
      Component: Icon,
      props: {
        styleName: stylesName,
        className: 'a-svg-large',
        icon: 'round_outlined_cancel',
      },
      title: 'Failed to save changes',
    },
    [success]: defaultView,
    [idle]: defaultView,
  };

  return options[state];
};

const ShareableReportTitledSpinner = ({ className, titleClassName, state }) => {
  if (!shareableReportInputState[state]) {
    return null;
  }

  const stylesName = bemClassName('m-shareable-report-titled-spinner', { [state]: true });

  const viewStylesName = bemClassName('m-shareable-report-titled-spinner__circle', {
    [state]: true,
  });

  const view = getViewFromState(state, viewStylesName);
  const { Component, props, title } = view;

  return (
    <div styleName={stylesName} className={className}>
      <Component {...props} />
      <div styleName="m-shareable-report-titled-spinner__title" className={titleClassName}>
        {title}
      </div>
    </div>
  );
};

ShareableReportTitledSpinner.propTypes = {
  className: PropTypes.string,
  titleClassName: PropTypes.string,
  state: PropTypes.oneOf([failure, success, loading, idle]),
};

export default CSSModules(ShareableReportTitledSpinner, styles, {
  allowMultiple: true,
});
